<section *ngIf="opts?.aberto" class="row m-0" [class.modal-aprovar]="opts.tipo === 1 && opts.aberto" [class.modal-reprovar]="opts.tipo === 0 && opts?.aberto" [class.modal-info]="opts.tipo === 2 && opts?.aberto">
  <div class="col-5" style="display: flex; justify-content: center;">
    <div class="card p-4">

      <div class="row mt-4">
        <div class="col-12 d-flex justify-content-center">
          <h3>
            {{opts.titulo}}
          </h3>
        </div>
        <div class="barra">
          <svg xmlns="http://www.w3.org/2000/svg" width="324" height="3" viewBox="0 0 324 3" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2.5C0.947718 2.5 0.5 2.05228 0.5 1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H322.5C323.052 0.5 323.5 0.947715 323.5 1.5C323.5 2.05228 323.052 2.5 322.5 2.5H1.5Z" fill="#EAEAEA" />
          </svg>
        </div>
        <div class="col-12">
          <p class="text-center">
            {{opts.descricao}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="opts.tipo == 0">
        <div class="col-6">
          <button class="w-100 btn-alta-enfase-verde-novo" (click)="cancelar()">{{opts.btnMsgCancelar}}</button>
        </div>
        <div class="col-6">
          <button class="w-100 btn-media-enfase-vermelho" (click)="confimar()">{{opts.btnMsgOk}}</button>
        </div>
      </div>

      <div class="row" *ngIf="opts.tipo == 1">
        <div class="col-6">
          <button class="w-100 btn-media-enfase-primario" (click)="cancelar()">{{opts.btnMsgCancelar}}</button>
        </div>
        <div class="col-6">
          <button class="w-100 btn-alta-enfase-vermelho-acrefi" (click)="confimar()">{{opts.btnMsgOk}}</button>
        </div>
      </div>

      <div class="row" *ngIf="opts.tipo == 2">
        <div class="col-12">
          <button class="w-100 btn-alta-enfase-primario" (click)="confimar()">{{opts.btnMsgOk}}</button>
        </div>
      </div>

    </div>

  </div>
</section>